import { TextSource } from './types';

/** Texte der Seite „Über uns". */
export const UEBERUNS: TextSource = {
  'ueberuns.hero.eyebrow': 'Über uns',
  'ueberuns.hero.titel': 'Wo Erfahrung, Herzlichkeit und',
  'ueberuns.hero.titel-akzent': 'Qualität Hand in Hand gehen.',
  'ueberuns.hero.absatz-1':
    'In der Seniorenbetreuung Antczak verbinden wir langjährige Erfahrung, herzliche Fürsorge und erstklassige Qualität, um älteren Menschen einen würdevollen Lebensabend in den eigenen vier Wänden zu ermöglichen — und gleichzeitig die Angehörigen zu entlasten.',
  'ueberuns.hero.absatz-2':
    'Wir legen großen Wert darauf, unsere Kunden persönlich kennenzulernen, bevor wir die passende Betreuung anbieten. So erfassen wir nicht nur die Anforderungen an die Betreuung, sondern auch die persönlichen Wünsche optimal — und stehen während der gesamten Betreuungszeit im ständigen Austausch mit Familien und Betreuungskräften.',
  'ueberuns.hero.absatz-3':
    'Unser Ziel ist es, für jede Familie zwei Betreuungskräfte zu finden, die sich im Verlauf des Jahres abwechseln — für eine beständige, verlässliche Betreuung, die sich an individuelle Bedürfnisse anpasst.',

  'ueberuns.wert-1.titel': 'Lokal, persönlich, verlässlich',
  'ueberuns.wert-1.text':
    'Unser Unternehmen aus Gifhorn ist eng mit der örtlichen Gemeinschaft verbunden. Mit individueller Betreuung und zuverlässigem Service stehen Ihre Bedürfnisse stets an erster Stelle.',
  'ueberuns.wert-2.titel': 'Immer in Ihrer Nähe',
  // Bewusst ohne Kilometerzahl: Der Radius ist je Leistung ein anderer — rund
  // 20 km für die stundenweise Betreuung, weil eigene Mitarbeiter hinfahren,
  // und deutlich mehr für die 24-Stunden-Betreuung, bei der die Betreuungskraft
  // im Haushalt wohnt. Hier stand bis zum 22.09.2026 pauschal „bis zu 30 km" und
  // widersprach damit beiden Leistungsseiten. Die Zahlen gehören dorthin, wo die
  // Leistung beschrieben wird (`hauswirtschaft.ts`, `betreuung24h.ts`), nicht in
  // einen allgemeinen Wert-Baustein, der beide Felder zugleich meint.
  'ueberuns.wert-2.text':
    'Wir arbeiten in Gifhorn und der Region und können so schnell auf die Bedürfnisse unserer Kunden reagieren. Wie weit wir fahren, steht bei der jeweiligen Leistung. Nähe, die zählt.',
  'ueberuns.wert-3.titel': 'Wie ein Familienunternehmen',
  'ueberuns.wert-3.text':
    'Wir pflegen einen familiären Ansatz, bei dem Wertschätzung und persönlicher Kontakt im Mittelpunkt für Ihr Wohlbefinden stehen.',
  'ueberuns.wert-4.titel': 'Kompetente Beratung',
  'ueberuns.wert-4.text':
    'Bei unserer unverbindlichen Beratung stehen Ihre Bedürfnisse im Mittelpunkt. Wir nehmen uns Zeit und erarbeiten gemeinsam maßgeschneiderte Lösungen für eine optimale Versorgung.',
  'ueberuns.wert-5.titel': 'Niederlassung & Partner in Polen',
  'ueberuns.wert-5.text':
    'Mit eigener Niederlassung und sorgfältig ausgewähltem Partner in Polen haben wir maximale Entscheidungsbefugnis bei der Personalauswahl — qualitativ hochwertig und rechtlich einwandfrei.',
  'ueberuns.wert-6.titel': 'Schnelle Hilfe',
  'ueberuns.wert-6.text':
    'In dringenden Situationen sind wir umgehend für Sie da. Situationen können unvorhersehbar sein — wir sind nahezu jederzeit für Sie erreichbar.',
  'ueberuns.wert-7.titel': 'Zweisprachige Expertise',
  'ueberuns.wert-7.text':
    'Deutsch und Polnisch: Diese sprachliche Vielfalt fördert die reibungslose Interaktion zwischen Betreuungskräften, der polnischen Seite und den Familien.',
  'ueberuns.wert-8.titel': 'Wenig Bürokratie',
  'ueberuns.wert-8.text':
    'Kurze, leicht verständliche Verträge mit flexiblen Kündigungszeiten und nur einem Vertragspartner — damit wir uns voll auf die Qualität konzentrieren können.',
  'ueberuns.wert-9.titel': '„Gepflegt Zuhause bleiben“',
  'ueberuns.wert-9.text':
    'Wir geben Senioren die Möglichkeit, in ihrem eigenen Zuhause zu bleiben — mit unschätzbarem Einfluss auf ihr seelisches und emotionales Wohlbefinden.',

  'ueberuns.team.titel': 'Unser Team',
  'ueberuns.team.text':
    'Unsere engagierten Mitarbeiter kümmern sich liebevoll, kompetent und einfühlsam um die Anliegen unserer Kunden.',

  'ueberuns.gruppe.titel': 'Antczak Group',

  'ueberuns.partner.titel': 'Unsere Partner',
  'ueberuns.partner.text':
    'Gute Versorgung entsteht im Zusammenspiel: Mit diesen Pflegediensten, Tagespflegen und Einrichtungen aus der Region arbeiten wir eng zusammen.',

  'ueberuns.cta.titel': 'Lernen wir uns kennen',
  'ueberuns.cta.text': 'Wir freuen uns auf ein persönliches, unverbindliches Gespräch mit Ihnen.',
  'ueberuns.cta.schaltflaeche': 'Kontakt aufnehmen',
};

export default UEBERUNS;
